import { render, staticRenderFns } from "./extendedPropertiesSearch.vue?vue&type=template&id=bc8d723c&scoped=true"
import script from "./extendedPropertiesSearch.vue?vue&type=script&lang=js"
export * from "./extendedPropertiesSearch.vue?vue&type=script&lang=js"
import style0 from "./extendedPropertiesSearch.vue?vue&type=style&index=0&id=bc8d723c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8d723c",
  null
  
)

export default component.exports